// extracted by mini-css-extract-plugin
module.exports = {"container":"prevention_container__RWPcp","header":"prevention_header__2PAbM","iframe":"prevention_iframe__2l3w8"};